import React from 'react';
import {
  Flex,
  Heading as ChakraHeading,
  HeadingProps as ChakraHeadingProps,
  Icon,
} from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import { FiChevronLeft } from 'react-icons/fi';

interface HeadingProps extends ChakraHeadingProps {
  hasBackButton?: boolean;
}

export const Heading: React.FC<HeadingProps> = ({
  children,
  hasBackButton = false,
  ...props
}) => {
  const history = useHistory();

  return (
    <Flex gridGap={2} align="center">
      {hasBackButton && (
        <Icon
          as={FiChevronLeft}
          fontSize="3xl"
          onClick={() => history.goBack()}
          cursor="pointer"
          color="gray.900"
        />
      )}
      <ChakraHeading fontSize="20px" {...props}>
        {children}
      </ChakraHeading>
    </Flex>
  );
};
